app.factory('flowMenuConfigurationService', ['propertyService', 'configurationService', function (propertyService, configurationService) {
    var service = {};

    service.getConfigurationModel = function (properties) {
        var configurationModel = configurationService.getConfigurationModel(properties);
        configurationModel.flowMenuId = propertyService.getPropertyValue(properties, "flowMenuId");
        return configurationModel;
    }

    service.getControllingModel = function () {
        return configurationService.getControllingModel();
    }

    service.saveProperties = function (properties, configurationModel, operation) {
        configurationService.saveProperties(properties, configurationModel);
        propertyService.setProperty(properties, "flowMenuId", configurationModel.flowMenuId);   
    }

    return service;
}]);